import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "device-manager" }
const _hoisted_2 = { class: "stat-number" }
const _hoisted_3 = { class: "stat-number" }
const _hoisted_4 = { class: "stat-number" }
const _hoisted_5 = { class: "stat-number" }
const _hoisted_6 = { class: "stat-number" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = { class: "search-grid" }
const _hoisted_9 = { style: {"grid-column":"1 / -1","display":"contents"} }
const _hoisted_10 = { class: "form-actions-wrapper" }
const _hoisted_11 = { class: "form-actions" }
const _hoisted_12 = { class: "table-bar" }
const _hoisted_13 = { class: "table-tools" }
const _hoisted_14 = { class: "drawer-container" }
const _hoisted_15 = { class: "device-info" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "log-content" }

import { ref } from 'vue'
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import { deviceDataStore, type Device } from '../data/deviceData'


export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceManager',
  setup(__props) {

const collapsed = ref(true)
const columns = [
  { title: '设备ID', dataIndex: 'id', key: 'id' },
  { title: '设备名称', dataIndex: 'name', key: 'name' },
  { title: '所属租户', dataIndex: 'tenant', key: 'tenant' },
  { title: '设备状态', dataIndex: 'status', key: 'status' },
  { title: 'SIM卡号', dataIndex: 'sim', key: 'sim' },
  { title: '租户编码', dataIndex: 'tenantCode', key: 'tenantCode' },
  {
    title: '操作',
    key: 'action',
    width: 120,
    fixed: 'right',
    slots: { customRender: 'action' }
  }
]
// 完整数据源
const allDeviceData = ref<Device[]>(deviceDataStore)
// 响应式表格数据
const deviceData = ref<Device[]>([])
// 查询条件
const searchForm = ref({
  id: '',
  name: '',
  status: '',
  tenant: '',
  sim: '',
  tenantCode: '',
})
const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
  onChange: (page: number, pageSize: number) => {
    pagination.value.current = page
    pagination.value.pageSize = pageSize
    loadData()
  }
})

function loadData() {
  const start = (pagination.value.current - 1) * pagination.value.pageSize
  const end = start + pagination.value.pageSize
  deviceData.value = allDeviceData.value.slice(start, end)
  pagination.value.total = allDeviceData.value.length
}

// 查询方法
// 统计数据
const statistics = ref({
  total: 0,
  unregistered: 0,
  online: 0,
  offline: 0,
  abnormal: 0
})

// 更新统计数据
function updateStatistics() {
  statistics.value.total = allDeviceData.value.length
  statistics.value.online = allDeviceData.value.filter(item => item.status === '在线').length
  statistics.value.offline = allDeviceData.value.filter(item => item.status === '离线').length
  statistics.value.unregistered = allDeviceData.value.filter(item => !item.status).length
  statistics.value.abnormal = allDeviceData.value.filter(item => item.status === '异常').length
}

// 修改重置方法
function handleReset() {
  searchForm.value = { id: '', name: '', status: '', tenant: '', sim: '', tenantCode: ''}
  allDeviceData.value = deviceDataStore.slice()
  pagination.value.current = 1
  loadData()
  updateStatistics() // 更新统计数据
}

// 修改查询方法
function handleSearch() {
  console.log('查询条件：', searchForm.value)
  // 过滤数据
  allDeviceData.value = deviceDataStore.filter(item => {
    return (
      (!searchForm.value.id || item.id.includes(searchForm.value.id)) &&
      (!searchForm.value.name || item.name.includes(searchForm.value.name)) &&
      // 修改状态过滤逻辑，当 searchForm.status 为空字符串（即选择“全部”）时，不进行状态过滤
      (searchForm.value.status === '' || !searchForm.value.status || item.status === searchForm.value.status) &&
      (!searchForm.value.tenant || item.tenant.includes(searchForm.value.tenant)) &&
      (!searchForm.value.sim || item.sim.includes(searchForm.value.sim)) &&
      (!searchForm.value.tenantCode || item.tenantCode.includes(searchForm.value.tenantCode))
    )
  })
  // 重置分页到第一页并加载数据
  pagination.value.current = 1
  loadData()
  updateStatistics() // 更新统计数据
}
// 页面加载时初始化
handleReset()
// 日志抽屉相关
const logDrawerVisible = ref(false)
const deviceLogs = ref<{ time: string; content: string }[]>([])
const logContent = ref('')
const currentDevice = ref<Device | null>(null)

// 生成随机时间
function generateRandomTime(baseTime: Date, offsetMinutes: number): string {
  const time = new Date(baseTime.getTime() + offsetMinutes * 60000)
  return time.toLocaleString('zh-CN', { 
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}

// 根据设备类型生成对应的日志内容
function generateDeviceLogs(device: Device): { time: string; content: string }[] {
  const logs: { time: string; content: string }[] = []
  const baseTime = new Date()

  if (device.name.includes('GPS')) {
    // GPS设备日志逻辑 (保持不变)
    logs.push({
      time: generateRandomTime(baseTime, -120),
      content: '设备上线'
    })
    for (let i = 0; i < 120; i++) {
      logs.push({
        time: generateRandomTime(baseTime, -120 + i),
        content: `数据上报：${generateDeviceData(device)}`
      })
    }
  } else {
    // 非GPS设备日志逻辑
    const startDate = new Date('2025-03-15T08:30:00')
    const endDate = new Date('2025-05-08T09:14:53')
    const dailyStartTimeHour = 8
    const dailyStartTimeMinute = 30
    const dailyEndTimeHour = 20
    const dailyEndTimeMinute = 0

    // Helper function to generate random time within the specified constraints
    const generateSpecificRandomTime = () => {
      let randomTimestamp;
      let attempts = 0
      do {
        attempts++
        // Randomly pick a day between startDate and endDate
        const randomDayTimestamp = startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime())
        const randomDate = new Date(randomDayTimestamp)

        // Randomly pick a time within the daily window (8:30 AM to 8:00 PM)
        const dayStartTime = new Date(randomDate)
        dayStartTime.setHours(dailyStartTimeHour, dailyStartTimeMinute, 0, 0)

        const dayEndTime = new Date(randomDate)
        dayEndTime.setHours(dailyEndTimeHour, dailyEndTimeMinute, 0, 0)

        let randomTimeInDay;
        // Ensure the generated time is within the 8:30 - 20:00 window
        const startMillis = dayStartTime.getTime()
        const endMillis = dayEndTime.getTime()
        
        if (startMillis >= endMillis) { // Should not happen with 8:30 to 20:00
            randomTimeInDay = startMillis;
        } else {
            randomTimeInDay = startMillis + Math.random() * (endMillis - startMillis)
        }

        randomTimestamp = new Date(randomTimeInDay)

        // Ensure the final timestamp is within the overall start and end date/time
        if (randomTimestamp.getTime() < startDate.getTime()) {
          randomTimestamp = new Date(startDate.getTime())
        }
        if (randomTimestamp.getTime() > endDate.getTime()) {
          randomTimestamp = new Date(endDate.getTime())
        }
        // Safety break for infinite loop, though unlikely with valid ranges
        if (attempts > 1000) {
            console.warn("Max attempts reached in generateSpecificRandomTime, returning endDate");
            return endDate.toLocaleString('zh-CN', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
            });
        }

      } while (randomTimestamp.getTime() < startDate.getTime() || 
               randomTimestamp.getTime() > endDate.getTime() ||
               randomTimestamp.getHours() < dailyStartTimeHour || 
               (randomTimestamp.getHours() === dailyStartTimeHour && randomTimestamp.getMinutes() < dailyStartTimeMinute) ||
               randomTimestamp.getHours() >= dailyEndTimeHour ||
               (randomTimestamp.getHours() === dailyEndTimeHour && randomTimestamp.getMinutes() > dailyEndTimeMinute) 
              );
      
      return randomTimestamp.toLocaleString('zh-CN', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      })
    }

    // Generate 120 log entries for non-GPS devices within the specified range
    // The first log can be '设备上线' or a regular data report.
    // For simplicity, let's make all of them data reports for now.
    for (let i = 0; i < 120; i++) {
      logs.push({
        time: generateSpecificRandomTime(),
        content: `数据上报：${generateDeviceData(device)}`
      })
    }
    // Add a final '设备离线' if it makes sense for the scenario, or keep as data reports.
    // For now, we'll keep it as 120 data reports.
  }

  return logs.sort((a, b) => new Date(a.time.replace(/\//g, '-')).getTime() - new Date(b.time.replace(/\//g, '-')).getTime()) // Ensure correct date parsing for sorting
}

// 根据设备名称生成不同的数据内容
function generateDeviceData(device: Device): string {
  // 通过设备名称判断设备类型
  if (device.name.includes('温湿度')) {
    return `温度 ${(20 + Math.random() * 10).toFixed(1)}℃, 湿度 ${(50 + Math.random() * 30).toFixed(1)}%`
  } else if (device.name.includes('电表')) {
    return `电压 ${(220 + Math.random() * 10).toFixed(1)}V, 电流 ${(5 + Math.random() * 2).toFixed(2)}A`
  } else if (device.name.includes('水表')) {
    return `用水量 ${(Math.random() * 100).toFixed(2)}m³`
  } else if (device.name.includes('气体') || device.name.includes('CO2')) {
    return `CO2浓度 ${(400 + Math.random() * 200).toFixed(0)}ppm`
  } else if (device.name.includes('门禁')) {
    return Math.random() > 0.5 ? '门已开启' : '门已关闭'
  } else if (device.name.includes('摄像头')) {
    return `视频流正常，清晰度 ${(720 + Math.random() * 480).toFixed(0)}p`
  } else if (device.name.includes('照明')) {
    return `亮度 ${(Math.random() * 100).toFixed(0)}%, 功率 ${(20 + Math.random() * 30).toFixed(0)}W`
  } else if (device.name.includes('GPS') || device.name.includes('定位')) {
    const latitude = (30 + Math.random() * 10).toFixed(6)
    const longitude = (110 + Math.random() * 10).toFixed(6)
    const speed = (Math.random() * 80).toFixed(1)
    return `位置：北纬 ${latitude}°, 东经 ${longitude}°, 速度 ${speed}km/h`
  } else if (device.name.includes('穿梭车') || device.name.includes('托盘')) {
    const position = Math.floor(Math.random() * 100)
    const battery = (20 + Math.random() * 80).toFixed(1)
    const load = Math.random() > 0.5 ? '已装载' : '未装载'
    const status = ['待命中', '任务执行中'][Math.floor(Math.random() * 2)]
    return `货架位置 ${position}号, 载货状态：${load}, 运行状态：${status}`
  } else if (device.name.includes('料箱')) {
    const station = Math.floor(Math.random() * 20)
    const battery = (20 + Math.random() * 80).toFixed(1)
    const boxCount = Math.floor(Math.random() * 4)
    const status = ['待命中', '取料中', '送料中'][Math.floor(Math.random() * 3)]
    return `工位 ${station}号, 料箱数量：${boxCount}, 运行状态：${status}`
  } else if (device.name.includes('超重超高堆垛机')) {
    const position = Math.floor(Math.random() * 200)
    const height = (20 + Math.random() * 30).toFixed(1)
    const weight = (1000 + Math.random() * 4000).toFixed(0)
    const battery = (20 + Math.random() * 80).toFixed(1)
    const load = Math.random() > 0.5 ? '已装载' : '未装载'
    const status = ['待命中', '取货中', '放货中', '移动中'][Math.floor(Math.random() * 4)]
    return `货位 ${position}号, 升降高度 ${height}米, 载重 ${weight}kg, 载货状态：${load}, 运行状态：${status}`
  } else if (device.name.includes('堆垛机')) {
    const position = Math.floor(Math.random() * 100)
    const height = Math.floor(Math.random() * 20)
    const battery = (20 + Math.random() * 80).toFixed(1)
    const load = Math.random() > 0.5 ? '已装载' : '未装载'
    const status = ['待命中', '取货中', '放货中', '移动中'][Math.floor(Math.random() * 4)]
    return `货位 ${position}号, 升降高度 ${height}米, 载货状态：${load}, 运行状态：${status}`
  } else if (device.name.includes('提升机')) {
    const floor = Math.floor(Math.random() * 10)
    const height = Math.floor(Math.random() * 30)
    const battery = (20 + Math.random() * 80).toFixed(1)
    const load = Math.random() > 0.5 ? '已装载' : '未装载'
    const status = ['待命中', '提升中', '下降中', '装载中', '卸载中'][Math.floor(Math.random() * 5)]
    return `当前楼层 ${floor}层, 提升高度 ${height}米, 载货状态：${load}, 运行状态：${status}`
  } else if (device.name.includes('行走马达')) {
    const rpm = (100 + Math.random() * 900).toFixed(0)
    const current = (10 + Math.random() * 20).toFixed(1)
    const temp = (40 + Math.random() * 40).toFixed(1)
    const status = ['正常运行', '低速运行', '加速中', '减速中', '停机中'][Math.floor(Math.random() * 5)]
    return `转速 ${rpm}rpm, 电流 ${current}A, 温度 ${temp}℃, 运行状态：${status}`
  } else if (device.name.includes('滚筒输送机')) {
    const speed = (0.1 + Math.random() * 0.4).toFixed(2)
    const load = Math.floor(Math.random() * 100)
    const current = (2 + Math.random() * 3).toFixed(1)
    const temp = (30 + Math.random() * 20).toFixed(1)
    const status = ['正常运行', '低速运行', '空载运行', '重载运行', '待机中'][Math.floor(Math.random() * 5)]
    return `输送速度 ${speed}m/s, 负载率 ${load}%, 电流 ${current}A, 温度 ${temp}℃, 运行状态：${status}`
  } else if (device.name.includes('转弯滚筒')) {
    const speed = (0.1 + Math.random() * 0.3).toFixed(2)
    const load = Math.floor(Math.random() * 100)
    const current = (2 + Math.random() * 3).toFixed(1)
    const temp = (30 + Math.random() * 20).toFixed(1)
    const angle = [30, 45, 60, 90, 180][Math.floor(Math.random() * 5)]
    const status = ['正常运行', '低速运行', '空载运行', '重载运行', '待机中'][Math.floor(Math.random() * 5)]
    return `输送速度 ${speed}m/s, 负载率 ${load}%, 电流 ${current}A, 温度 ${temp}℃, 转弯角度 ${angle}°, 运行状态：${status}`
  } else if (device.name.includes('风淋')) {
    const pressure = (0.2 + Math.random() * 0.3).toFixed(2)
    const flow = (20 + Math.random() * 10).toFixed(1)
    const duration = Math.floor(Math.random() * 30)
    const humidity = (60 + Math.random() * 20).toFixed(1)
    const status = ['待机中', '预备中', '风淋中', '完成'][Math.floor(Math.random() * 4)]
    return `风压 ${pressure}MPa, 风速 ${flow}m/s, 已淋风时间 ${duration}秒, 湿度 ${humidity}%, 运行状态：${status}`
  } else if (device.name.includes('AGV')) {
    const position = Math.floor(Math.random() * 100)
    const speed = (0.5 + Math.random() * 1.0).toFixed(2)
    const battery = (20 + Math.random() * 80).toFixed(1)
    const load = Math.random() > 0.5 ? '已装载' : '未装载'
    const direction = ['前进', '后退', '左转', '右转', '停止'][Math.floor(Math.random() * 5)]
    const status = ['待命中', '任务执行中', '充电中', '避障中'][Math.floor(Math.random() * 4)]
    return `当前位置 ${position}号, 速度 ${speed}m/s, 电量 ${battery}%, 载货状态：${load}, 运动方向：${direction}, 运行状态：${status}`
  } else {
    return `状态正常，信号强度 ${(60 + Math.random() * 30).toFixed(0)}%`
  }
}

// 修改查看日志方法
function viewLog(record: Device) {
  console.log('查看设备日志：', record.id)
  currentDevice.value = record
  // 生成设备对应的日志数据
  deviceLogs.value = generateDeviceLogs(record)
  // 格式化日志内容
  logContent.value = deviceLogs.value
    .map(log => `[${log.time}] ${log.content}`)
    .join('\n')
  logDrawerVisible.value = true
  
  // 等待 DOM 更新后滚动到底部
  setTimeout(() => {
    const textarea = document.querySelector('.log-content .ant-input') as HTMLTextAreaElement
    if (textarea) {
      textarea.scrollTop = textarea.scrollHeight
    }
  }, 100)
}

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, {
            gutter: 24,
            class: "mb16"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { class: "stat-card" }, {
                    default: _withCtx(() => [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-title" }, "设备总数", -1)),
                      _createElementVNode("div", _hoisted_2, _toDisplayString(statistics.value.total), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { class: "stat-card" }, {
                    default: _withCtx(() => [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "stat-title" }, "注册未上线设备", -1)),
                      _createElementVNode("div", _hoisted_3, _toDisplayString(statistics.value.unregistered), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { class: "stat-card" }, {
                    default: _withCtx(() => [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-title" }, "当前在线", -1)),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(statistics.value.online), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { class: "stat-card" }, {
                    default: _withCtx(() => [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stat-title" }, "当前离线", -1)),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(statistics.value.offline), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { class: "stat-card" }, {
                    default: _withCtx(() => [
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "stat-title" }, "在线异常", -1)),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(statistics.value.abnormal), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "search-title" }, "设备查询", -1)),
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_form_item, { label: "设备ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchForm.value.id,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.value.id) = $event)),
                        placeholder: "请输入设备ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "设备名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchForm.value.name,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.value.name) = $event)),
                        placeholder: "请输入设备名称"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "设备状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchForm.value.status,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.value.status) = $event)),
                        placeholder: "请选择设备状态",
                        allowClear: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: "" }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("全部")
                            ])),
                            _: 1
                          }),
                          _cache[17] || (_cache[17] = _createTextVNode(" // 添加“全部”选项 ")),
                          _createVNode(_component_a_select_option, { value: "在线" }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode("在线")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "离线" }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("离线")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_form_item, { label: "所属用户" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: searchForm.value.tenant,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.value.tenant) = $event)),
                          placeholder: "请输入所属用户"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, { label: "SIM卡号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: searchForm.value.sim,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.value.sim) = $event)),
                          placeholder: "请输入SIM卡号"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, { label: "租户编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: searchForm.value.tenantCode,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchForm.value.tenantCode) = $event)),
                          placeholder: "请输入租户编码"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, !collapsed.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: handleSearch
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode("查询")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createTextVNode("重置")
                      ])),
                      _: 1
                    }),
                    _createElementVNode("a", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (collapsed.value = !collapsed.value)),
                      class: "collapse-link"
                    }, [
                      _createTextVNode(_toDisplayString(collapsed.value ? '更多查询' : '收起查询') + " ", 1),
                      (collapsed.value)
                        ? (_openBlock(), _createBlock(_unref(DownOutlined), { key: 0 }))
                        : (_openBlock(), _createBlock(_unref(UpOutlined), { key: 1 }))
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_button, { type: "text" }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-list" })
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "text" }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-table-cells-large" })
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "text" }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-gear" })
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "default" }, {
                icon: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file-export" })
                ]),
                default: _withCtx(() => [
                  _cache[21] || (_cache[21] = _createTextVNode("导出"))
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_a_button, { type: "primary" }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode("+ 新增")
              ])),
              _: 1
            })
          ]),
          _createVNode(_component_a_table, {
            columns: columns,
            "data-source": deviceData.value,
            pagination: pagination.value,
            style: {"margin-top":"16px"}
          }, {
            action: _withCtx(({ record }) => [
              _createVNode(_component_a_button, {
                type: "link",
                size: "small",
                onClick: ($event: any) => (viewLog(record))
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createTextVNode("查看日志")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            emptyText: _withCtx(() => [
              _createVNode(_component_a_empty, { description: "暂无数据" })
            ]),
            _: 1
          }, 8, ["data-source", "pagination"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_drawer, {
      title: "设备日志",
      placement: "right",
      width: 600,
      visible: logDrawerVisible.value,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (logDrawerVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "label" }, "设备ID：", -1)),
              _createElementVNode("div", _hoisted_17, _toDisplayString(currentDevice.value?.id), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "label" }, "设备名称：", -1)),
              _createElementVNode("div", _hoisted_19, _toDisplayString(currentDevice.value?.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_a_textarea, {
              value: logContent.value,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((logContent).value = $event)),
              readonly: "",
              placeholder: deviceLogs.value.length ? '' : '暂无日志数据'
            }, null, 8, ["value", "placeholder"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})